import React, { useEffect, useState } from "react";
import "../assets/css/AñadirParametros.css";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { getParametroByID, getUpdateData, deleteParametro, updateParametro, getCurrentUser } from "../services/API";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import socket from "../assets/js/socket";
import axios from "axios";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";

const VistaParametrosLectura = () => {
    const navigate = useNavigate();
    const [reglas, setReglas] = useState([]);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [dataAdgroups, setDataAdgroups] = useState([]);
    const [dataCampaign, setDataCampaign] = useState([]);
    const [dataPortafolios, setDataPortafolios] = useState([]);
    const [dataProductos, setDataProductos] = useState([]);
    const [copiesRealTime, setCopiesRealTime] = useState({});
    const [isOpen, setIsOpen] = useState({});
    const [selectedSection, setSelectedSection] = useState("RISK");
    const [selectedFunction, setSelectedFunction] = useState("Select");
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [checkboxes, setCheckboxes] = useState({});
    const [tituloInformacion, setTituloInformacion] = useState("");
    const [, setShowDropdown] = useState(false);
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showRevertModal, setShowRevertModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [actualData, setActualData] = useState({});
    const [actualNombre, setActualNombre] = useState("");
    const [selectedCampaignType, setSelectedCampaignType] = useState("SP");
    const [currentUserID, setCurrentUserID] = useState(null);


    const giveNewID = () => {
        let find = false;
        let Id = 1;
        while (!find) {
            if (reglas.filter((regla) => regla.id === Id).length === 0) find = true;
            else Id = Id + 1;
        }
        return Id;
    }

    const generarDestiny = (data, tipo) => {
        if (Object.keys(checkboxes).length === 0)
            return "No se ha seleccionado ningún destino.";
        const idsSeleccionados = Object.keys(checkboxes).filter(id => checkboxes[id]);
        const portafolios = copiesRealTime.portafolios;
        const campanas = copiesRealTime.campaigns;
        const dataProductos = copiesRealTime.productos;
        if (idsSeleccionados.length === 0)
            return "No se ha seleccionado ningún destino.";
        else {
            switch (tipo) {
                case "Adgroups":
                    const campaignsFormateadas = [];
                    for (const campaign of campanas) {
                        const adGroupsFiltrados = campaign.adGroups?.filter(ad => idsSeleccionados.includes(ad.adGroupId));

                        if (adGroupsFiltrados && adGroupsFiltrados.length > 0) {
                            campaignsFormateadas.push({
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" :
                                    campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: adGroupsFiltrados.map(ad => ({
                                    adGroupId: ad.adGroupId,
                                    adGroupName: ad.name
                                }))
                            });
                        }
                    }
                    data.destinations = { campaigns: campaignsFormateadas };
                    break;
                case "Campaigns":
                    const campaignsSeleccionadas = [];
                    for (const campaign of campanas) {
                        if (idsSeleccionados.includes(campaign.campaignId)) {
                            campaignsSeleccionadas.push({
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" :
                                    campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: campaign.adGroups?.map(ad => ({
                                    adGroupId: ad.adGroupId,
                                    adGroupName: ad.name
                                })) || []
                            });
                        }
                    }
                    data.destinations = { campaigns: campaignsSeleccionadas };
                    break;
                case "Portafolios":
                    const portfoliosFormateados = [];
                    for (const portfolio of portafolios) {
                        if (idsSeleccionados.includes(portfolio.portfolioId)) {
                            const campaignsFormateadas = campanas
                                .filter(campaign => campaign.portfolioId === portfolio.portfolioId)
                                .map(campaign => ({
                                    campaignId: campaign.campaignId,
                                    campaignName: campaign.name,
                                    Type: campaign.type === "SP" ? "Sponsored Products" :
                                        campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                    adGroups: (campaign.adGroups || []).map(ad => ({
                                        adGroupId: ad.adGroupId,
                                        adGroupName: ad.name
                                    }))
                                }));
                            portfoliosFormateados.push({
                                portfolioId: portfolio.portfolioId,
                                portfolioName: portfolio.name,
                                campaigns: campaignsFormateadas
                            });
                        }
                    }
                    data.destinations = { portfolios: portfoliosFormateados };
                    break;
                case "Asins":
                    const productosFormateados = [];
                    for (const producto of dataProductos) {
                        if (idsSeleccionados.includes(producto.adId)) {
                            const campaign = campanas.find(c => c.campaignId === producto.campaignId);
                            const adGroup = campaign?.adGroups?.find(ad => ad.adGroupId === producto.adGroupId);
                            const campaignFormateada = campaign ? {
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" :
                                    campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: adGroup ? [{
                                    adGroupId: adGroup.adGroupId,
                                    adGroupName: adGroup.name
                                }] : []
                            } : null;
                            productosFormateados.push({
                                asin: producto.asin,
                                sku: producto.sku,
                                state: producto.state,
                                campaigns: campaignFormateada ? [campaignFormateada] : []
                            });
                        }
                    }
                    data.destinations = { asins: productosFormateados };
                    break;
                default:
                    break;
            }
            return "";
        }
    };

    const handleSave = async () => {
        setShowSaveModal(false);
        for (const regla of reglas) {
            console.log(regla);
            if ((!regla.tipoRegla || !regla.configuracion) || (regla.tipoRegla === "Numérico" && !regla.range) || (regla.tipoRegla === "Textual" && regla.campoTexto.trim() === "")) {
                alertify.notify("Por favor completa todos los campos de cada regla.", "error", 5);
                return;
            }
        }
        const recogerDatosFormulario = () => {
            const datos = {
                type: selectedCampaignType === "SP" ? 1 : 2,
                destino: selectedFunction,
                seccion: selectedSection,
                nombreParametro: document.getElementById("name_new_iem").value,
                reglas: reglas.map((regla) => {
                    if (regla.tipoRegla === "Textual") {
                        return {
                            tipoRegla: regla.tipoRegla,
                            configuracion: regla.configuracion,
                            text: regla.campoTexto
                        };
                    } else if (regla.tipoRegla === "Numérico") {
                        return {
                            tipoRegla: regla.tipoRegla,
                            configuracion: regla.configuracion,
                            number: parseFloat(regla.campoTexto),
                            range: regla.range
                        };
                    } else {
                        return {};
                    }
                })
            };

            if (!datos.destino || !datos.seccion) {
                alertify.notify("Los campos Destino y Sección son obligatorios.", "error", 5);
                return null;
            }

            const construirRules = (datos, operadores) => {
                const reglas = datos.reglas;
                const rules = [];
                reglas.forEach((regla, index) => {
                    const rule = {
                        name: "R" + (index + 1),
                        type: regla.tipoRegla,
                        configuration: regla.configuracion
                    };

                    if (regla.tipoRegla === "Textual") {
                        rule.text = regla.text;
                    } else if (regla.tipoRegla === "Numérico") {
                        rule.number = regla.number;
                        rule.range = regla.range;
                    }
                    rules.push(rule);
                    if (index < operadores.length) {
                        rules.push({
                            operator: operadores[index].toUpperCase()
                        });
                    }
                });
                return rules;
            };
            let operadores = reglas.map(regla => regla.operador).filter(operador => operador !== "");
            datos.rules = construirRules(datos, operadores);
            return datos;
        }

        const data = recogerDatosFormulario();
        if (!data) return;

        const errorMessage = generarDestiny(data, selectedFunction);
        if (errorMessage !== "") {
            alertify.notify(errorMessage, "error", 5);
            return;
        }
        const response = await updateParametro(data, localStorage.getItem("parametro"));
        (response.error) ? alertify.notify(response.error, "error", 5) : alertify.notify("Parámetro actualizado. Redirigiendo...", "success", 5);
        setTimeout(() => navigate("/parametros"), 2000);
    };

    const handleDelete = async () => {
        const id = localStorage.getItem("parametro");
        setShowDeleteModal(false);
        alertify.notify("Eliminando parámetro...", "warning", 5);
        await deleteParametro(id);
        localStorage.removeItem("parametro");
        alertify.notify("Parámetro eliminado. Redirigiendo...", "success", 5);
        setTimeout(() => navigate("/parametros"), 2000);
    }

    const handleRevert = () => {
        cargarDatos(actualData);
        setShowRevertModal(false);
        alertify.notify("Cambios deshechos", "success", 5)
        setModoEdicion(false);
    }

    const handleAñadirRegla = () => {
        if (reglas.length < 3) {
            setReglas((prevReglas) => {
                const nuevasReglas = [...prevReglas];
                if (nuevasReglas.length > 0) {
                    nuevasReglas[nuevasReglas.length - 1] = {
                        ...nuevasReglas[nuevasReglas.length - 1],
                        operador: "and"
                    };
                }
                nuevasReglas.push({
                    id: giveNewID(),
                    tipoRegla: "",
                    configuracion: "",
                    campoTexto: "",
                    operador: "",
                    range: ""
                });
                return nuevasReglas;
            });
            alertify.notify("Regla añadida", "success", 5);
        } else {
            alertify.notify("Solo puede haber tres reglas por parámetro", "error", 5);
        }
    };

    const changeDestination = (option) => {
        setSelectedFunction(option);
        setShowDropdown(false);
        setTituloInformacion(option);
        setCheckboxes({});
    };

    const handleSectionSelect = (sectionName) => setSelectedSection(sectionName);

    const toggleOpen = (itemId) => setIsOpen((prev) => ({ ...prev, [itemId]: !prev[itemId] }));

    const handleCheckboxChange = (id) => {
        setCheckboxes((prev) => {
            return {
                ...prev,
                [id]: !prev[id]
            };
        });
    };

    const handleSelectAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = true);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = true;
                });
            }
            else if (selectedFunction === "Portafolios") {
                dataPortafolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = true;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = true;
                });
            }
            return newState;
        });
    };

    const handleClearAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = false);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = false;
                });
            }
            else if (selectedFunction === "Portafolios") {
                dataPortafolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = false;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = false;
                });
            }
            return newState;
        });
    };

    const handleFilterClick = (filtro) => {
        setStatusFilter(filtro);
    };

    const getDataRealTime = (response) => {
        const campaigns = response.data.campaigns.map(campaign => ({
            ...campaign,
            adGroups: campaign.adGroups.filter(group => group.state !== "ARCHIVED")
        }))
            .filter(campaign => campaign.adGroups.length > 0);

        const productos = response.data.productos.map(producto => ({
            ...producto,
            campaigns: producto.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(producto => producto.campaigns.length > 0 && producto.state !== "ARCHIVED")

        const portafolios = response.data.portfolios.map(portafolio => ({
            ...portafolio,
            campaigns: portafolio.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(portafolio => portafolio.campaigns.length > 0 && portafolio.state !== "ARCHIVED")

        setDataAdgroups(campaigns);
        setDataProductos(productos);
        setDataCampaign(campaigns);
        setDataPortafolios(portafolios);
        setCopiesRealTime({
            adgroups: campaigns,
            campaigns: campaigns,
            portafolios: portafolios,
            productos: productos
        });
    }

    useEffect(() => {
        (async () => {
            const accountID = localStorage.getItem("selectedAccountValue");
            const response = await getUpdateData(accountID);
            getDataRealTime(response);
        })();
    }, [setDataAdgroups, setDataCampaign, setDataPortafolios, setCopiesRealTime, setDataProductos]);

    const notifyBOT = async () => {
        await axios.get("https://bot.jungleclick.online");
        console.log("BOT notificado.");
    }

    const cargarDatos = (data) => {

        const segmentationMap = {
            1: "RISK",
            2: "NEUTRAL",
            3: "SECURE"
        };

        const destinationMap = {
            1: "Adgroups",
            2: "Campaigns",
            3: "Portafolios",
            4: "Asins"
        };
        const segmentationText = segmentationMap[data.segmentation_id] || "Desconocido";
        const destinationText = destinationMap[data.destination_id] || "Desconocido";
        const reglasParseadas = parsearReglas(JSON.parse(data.rules));

        const type = data.sponsored_type_id === 1 ? "SP" : "SB";

        setSelectedCampaignType(type)
        setReglas(reglasParseadas);
        setSelectedSection(segmentationText);
        setSelectedFunction(destinationText);
        setActualNombre(data.name);

        const destinos = JSON.parse(data.destinations);

        const nuevosChecks = {};

        if (data.destination_id === 1) {
            destinos.campaigns.forEach(camp => {
                camp.adGroups.forEach(ad => {
                    nuevosChecks[ad.adGroupId] = true;
                });
            });
        } else if (data.destination_id === 2) {
            destinos.campaigns.forEach(camp => {
                nuevosChecks[camp.campaignId] = true;
            });
        } else if (data.destination_id === 3) {
            destinos.portfolios.forEach(port => {
                nuevosChecks[port.portfolioId] = true;
            });
        } else if (data.destination_id === 4) {
            destinos.asins.forEach(prod => {
                nuevosChecks[prod.asin] = true;
            });
        }
        setCheckboxes(nuevosChecks);
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const currentUser = await getCurrentUser();
                setCurrentUserID(currentUser.id);
            } catch (error) {
                console.error("Error al obtener datos:", error);
            };
        }
        fetchData();
    }, [])

    useEffect(() => {
        const handleConnect = () => {
            console.log("✅ Conectado al servidor WebSocket:", socket.id);
            notifyBOT();
        };

        const handleUpdate = (data) => {
            console.log("🔄 Actualización recibida:", data);
            const account = localStorage.getItem("selectedAccountValue")
            if (data.data.accountId == account)
                getDataRealTime(data.data.data);
            else
                console.log("Actualización omitida");
        };

        socket.on("connect", handleConnect);
        socket.on("update", handleUpdate);

        return () => {
            socket.off("connect", handleConnect);
            socket.off("update", handleUpdate);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const result = await getParametroByID(localStorage.getItem("parametro"));
            const data = result.data[0];
            setActualData(data);
            cargarDatos(data);
        };
        fetchData();
    }, []);

    const parsearReglas = (data) => {
        let resultado = [];
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            if (item.operator) {
                resultado[resultado.length - 1].operador = item.operator.toLowerCase();
            } else {
                resultado.push({
                    id: resultado.length + 1,
                    tipoRegla: item.type,
                    configuracion: item.configuration,
                    campoTexto: item.text || item.number,
                    range: item.range || null,
                    operador: ""
                });
            }
        }
        return resultado;
    };

    const handleFunctionSelect = (option) => {
        if (selectedFunction === "Select" || selectedFunction.trim() === "")
            changeDestination(option);
        else
            alertify.confirm("Cambio de destino", "Se perderan los checkbox del destino actual, desea continuar?", () => {
                changeDestination(option);
            }, () => alertify.error("Operación cancelada"));
    };

    const handleEditar = () => setModoEdicion(!modoEdicion);

    const handleEliminarRegla = (id) => {
        alertify.confirm("Eliminación", "¿Desea eliminar esta regla?", () => {
            setReglas((prev) => prev.filter((r) => r.id !== id));
        }, () => alertify.error("Operación cancelada"));
    };

    const actualizarRegla = (id, campo, valor) => {
        setReglas((prev) =>
            prev.map((r) => (r.id === id ? { ...r, [campo]: valor } : r))
        );
    };

    useEffect(() => {
        if (!copiesRealTime || (!copiesRealTime.campaigns && !copiesRealTime.portafolios && !copiesRealTime.productos)) {
            setDataAdgroups([]);
            setDataCampaign([]);
            setDataPortafolios([]);
            setDataProductos([]);
            return;
        }

        const campaignMatchesType = (campaign) => campaign.type === selectedCampaignType;
        const textMatcher = (name) => name && name.toLowerCase().includes(searchText.toLowerCase());

        if (selectedFunction === "Adgroups") {
            let resultAdgroups = copiesRealTime.campaigns ? [...copiesRealTime.campaigns] : [];

            resultAdgroups = resultAdgroups.filter(campaignMatchesType);

            if (statusFilter !== "ALL") {
                resultAdgroups = resultAdgroups.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => adgroup.state === statusFilter)
                })).filter(campaign => campaign.adGroups.length > 0);
            }

            if (searchText.trim() !== "") {
                resultAdgroups = resultAdgroups.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => textMatcher(adgroup.name))
                })).filter(campaign => campaign.adGroups.length > 0);
            }
            setDataAdgroups(resultAdgroups);

        } else if (selectedFunction === "Campaigns") {
            let resultCampaigns = copiesRealTime.campaigns ? [...copiesRealTime.campaigns] : [];

            resultCampaigns = resultCampaigns.filter(campaignMatchesType);

            if (statusFilter !== "ALL") {
                resultCampaigns = resultCampaigns.filter(campaign => campaign.state === statusFilter);
            }

            if (searchText.trim() !== "") {
                resultCampaigns = resultCampaigns.filter(campaign => textMatcher(campaign.name));
            }
            setDataCampaign(resultCampaigns);

        } else if (selectedFunction === "Portafolios") {
            let resultPortafolios = copiesRealTime.portafolios ? [...copiesRealTime.portafolios] : [];

            if (statusFilter !== "ALL") {
                resultPortafolios = resultPortafolios.filter(portafolio => portafolio.state === statusFilter);
            }

            if (searchText.trim() !== "") {
                resultPortafolios = resultPortafolios.filter(portafolio => textMatcher(portafolio.name || "Sin Portafolio"));
            }
            setDataPortafolios(resultPortafolios);

        } else if (selectedFunction === "Asins") {
            let resultProductos = copiesRealTime.productos ? [...copiesRealTime.productos] : [];

            if (statusFilter === "ENABLED" || statusFilter === "PAUSED") {
                alertify.notify("Los Asins no tiene el atributo State", "warning", 5);
            }

            if (searchText.trim() !== "") {
                resultProductos = resultProductos.filter(asin => textMatcher(asin.asin || "Sin Asin"));
            }
            setDataProductos(resultProductos);

        } else {
            const baseCampaigns = copiesRealTime.campaigns ? copiesRealTime.campaigns.filter(campaignMatchesType) : [];
            const adgroupsData = copiesRealTime.campaigns
                ? copiesRealTime.campaigns.filter(campaignMatchesType).map(c => ({ ...c, adGroups: c.adGroups || [] }))
                : [];
            setDataAdgroups(adgroupsData);
            setDataCampaign(baseCampaigns);
            setDataPortafolios(copiesRealTime.portafolios || []);
            setDataProductos(copiesRealTime.productos || []);
        }

    }, [
        copiesRealTime,
        searchText,
        statusFilter,
        selectedFunction,
        selectedCampaignType,
        setDataAdgroups,
        setDataCampaign,
        setDataPortafolios,
        setDataProductos
    ]);

    return (
        <Layout>
            <div className="contenedor-principal">
                <main className="container-fluid bg-white">
                    <div className="row">
                        <div className="col-7 px-3 py-3 bg-white border border-2 border-dark">
                            <div className="mt-5 d-flex justify-content-center align-items-center flex-column">
                                <h2 className="text-center mx-1">Vista de Parámetro</h2>
                                <div className="d-flex justify-content-end my-3">
                                    {!modoEdicion && (
                                        <>
                                            <button className="btn btn-primary mx-2" onClick={handleEditar} disabled={actualData.users_id !== currentUserID}>
                                                Activar edición
                                            </button>
                                            <button className="btn btn-danger mx-2" onClick={() => navigate("/parametros")}>
                                                Volver a la lista
                                            </button>
                                        </>
                                    )}
                                    {modoEdicion && (
                                        <>
                                            <button
                                                className="btn btn-success mx-2"
                                                onClick={() => setShowSaveModal(true)}
                                            >
                                                Guardar cambios
                                            </button>
                                            <button
                                                className="btn btn-warning mx-2"
                                                onClick={() => setShowRevertModal(true)}
                                            >
                                                Deshacer cambios
                                            </button>
                                            <button
                                                className="btn btn-danger mx-2"
                                                onClick={() => setShowDeleteModal(true)}
                                            >
                                                Eliminar parámetro
                                            </button>
                                        </>
                                    )}

                                </div>
                            </div>
                            <div className="filtros-superiores">
                                <div className="grupo-filtro1 mx-2 flex-column">
                                    <label className="mt-2 fs-5" htmlFor="destination-select">Destino:</label>
                                    <select
                                        id="destination-select"
                                        className="form-select"
                                        disabled={!modoEdicion}
                                        value={selectedFunction}
                                        onChange={(e) => { handleFunctionSelect(e.target.value) }}
                                    >
                                        <option value="">Seleccione una opción</option>
                                        <option value="Adgroups">Adgroups</option>
                                        <option value="Campaigns">Campaigns</option>
                                        <option value="Portafolios">Portafolios</option>
                                        <option value="Asins">Asins</option>
                                    </select>
                                </div>
                                <div className="grupo-filtro1 mx-2 flex-column">
                                    <label className="mt-2 fs-6" htmlFor="campaign-type-select">Sponsored Type:</label>
                                    <select
                                        id="campaign-type-select"
                                        className="form-select"
                                        disabled={!modoEdicion}
                                        value={selectedCampaignType}
                                        onChange={(e) => {
                                            const nuevoTipo = e.target.value;
                                            const hayChecks = Object.values(checkboxes).some((v) => v === true);
                                            if (hayChecks) {
                                                alertify.confirm(
                                                    "Cambio de tipo Sponsored Type",
                                                    "Se perderán las selecciones actuales. ¿Desea continuar?",
                                                    () => {
                                                        setSelectedCampaignType(nuevoTipo);
                                                        setCheckboxes({});
                                                    },
                                                    () => alertify.error("Operación cancelada")
                                                );
                                            } else {
                                                setSelectedCampaignType(nuevoTipo);
                                                setCheckboxes({});
                                            }
                                        }}
                                    >

                                        <option value="SP">Sponsored Products (SP)</option>
                                        <option value="SB">Sponsored Brands (SB)</option>
                                    </select>
                                </div>
                                <div className="grupo-filtro2 mx-2 flex-column">
                                    <label className="mt-2 fs-5" htmlFor="section-select">Sección:</label>
                                    <select
                                        id="section-select"
                                        className="form-select"
                                        disabled={!modoEdicion}
                                        value={selectedSection}
                                        onChange={(e) => handleSectionSelect(e.target.value)}
                                    >
                                        <option value="">Seleccione una opción</option>
                                        <option value="RISK">RISK</option>
                                        <option value="NEUTRAL">NEUTRAL</option>
                                        <option value="SECURE">SECURE</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col-12 mb-3">
                                    <label className="fs-5">Nombre del Parámetro:</label>
                                </div>
                                <div className="col-6">
                                    <input disabled={!modoEdicion} id="name_new_iem" onChange={(e) => setActualNombre(e.target.value)} value={actualNombre} className="input-form-text " type="text" placeholder="Ingrese un Nombre" />
                                </div>
                                <div className="col-6">
                                    <button className="btn btn-primary" disabled={!modoEdicion} onClick={handleAñadirRegla}>
                                        <i className="bi bi-plus"></i>Añadir Regla
                                    </button>
                                </div>
                            </div>
                            {reglas.map((regla, index) => (
                                <React.Fragment key={regla.id}>
                                    <div className="regla-container border rounded p-3 mb-3">
                                        <h5 className="my-3">Regla: R{index + 1}</h5>
                                        <div className="row mb-2">
                                            <div className="col-md-6">Tipo de Regla:</div>
                                            <div className="col-md-6">
                                                <select
                                                    disabled={!modoEdicion}
                                                    className="form-select"
                                                    value={regla.tipoRegla}
                                                    onChange={(e) =>
                                                        actualizarRegla(regla.id, "tipoRegla", e.target.value)
                                                    }
                                                >
                                                    <option value="">Seleccione</option>
                                                    <option value="Textual">Textual</option>
                                                    <option value="Numérico">Numérico</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-md-6">Configuración:</div>
                                            <div className="col-md-6">
                                                <select
                                                    disabled={!modoEdicion}
                                                    className="form-select"
                                                    value={regla.configuracion}
                                                    onChange={(e) =>
                                                        actualizarRegla(regla.id, "configuracion", e.target.value)
                                                    }
                                                >
                                                    <option value="">Seleccione</option>
                                                    {regla.tipoRegla === "Numérico" ? (
                                                        <>
                                                            <option value="Impresiones">Impresiones</option>
                                                            <option value="Clicks">Clicks</option>

                                                            {(selectedCampaignType === "SP") && (
                                                                <>
                                                                    <option value="7d Total Sales">7d Total Sales</option>
                                                                    <option value="7d Total Orders">7d Total Orders</option>
                                                                    <option value="Click-Thru Rate">Click-Thru Rate</option>
                                                                    <option value="ACOS">ACOS</option>
                                                                    <option value="ROAS">ROAS</option>
                                                                </>
                                                            )}

                                                            {(selectedCampaignType === "SB") && (
                                                                <>
                                                                    <option value="View Click Through Rate">View Click Through Rate</option>
                                                                </>
                                                            )}

                                                            <option value="Spend">Spend</option>
                                                            <option value="Cost per Click">Cost per Click</option>

                                                        </>
                                                    ) : (
                                                        <>
                                                            <option value="Contiene">Contiene</option>
                                                            <option value="No Contiene">No Contiene</option>
                                                            <option value="Es Igual a">Es Igual a</option>
                                                            <option value="No es Igual a">No es Igual a</option>
                                                            <option value="Empieza por">Empieza por</option>
                                                            <option value="Termina por">Termina por</option>
                                                        </>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                        {regla.tipoRegla === "Numérico" && (
                                            <div className="row mb-2">
                                                <div className="col-md-6">Rango:</div>
                                                <div className="col-md-6">
                                                    <select
                                                        disabled={!modoEdicion}
                                                        className="form-select"
                                                        value={regla.range}
                                                        onChange={(e) =>
                                                            actualizarRegla(regla.id, "range", e.target.value)
                                                        }
                                                    >
                                                        <option value="">Seleccione</option>
                                                        <option value="Mayor a">Mayor a</option>
                                                        <option value="Igual a">Igual a</option>
                                                        <option value="Menor a">Menor a</option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        <div className="row mb-2">
                                            <div className="col-md-6">
                                                {regla.tipoRegla === "Textual" ? "Texto:" : "Número:"}
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    disabled={!modoEdicion}
                                                    className="form-control"
                                                    value={regla.campoTexto}
                                                    onChange={(e) =>
                                                        actualizarRegla(regla.id, "campoTexto", e.target.value)
                                                    }
                                                    type={regla.tipoRegla === "Numérico" ? "number" : "text"}
                                                />
                                            </div>
                                        </div>

                                        <div className="text-end">
                                            <button
                                                className="btn btn-danger btn-sm my-3"
                                                disabled={!modoEdicion}
                                                onClick={() => handleEliminarRegla(regla.id)}
                                            >
                                                Eliminar
                                            </button>
                                        </div>
                                    </div>

                                    {index < reglas.length - 1 && (
                                        <div className="mb-4 d-flex justify-content-center align-items-center">
                                            <label className="me-3">
                                                <input
                                                    disabled={!modoEdicion}
                                                    type="radio"
                                                    value="and"
                                                    className="form-check-input border border-1 border-dark mx-2"
                                                    checked={regla.operador === "and"}
                                                    onChange={() =>
                                                        actualizarRegla(regla.id, "operador", "and")
                                                    }
                                                />
                                                AND
                                            </label>
                                            <label>
                                                <input
                                                    disabled={!modoEdicion}
                                                    type="radio"
                                                    value="or"
                                                    className="form-check-input border border-1 border-dark mx-2"
                                                    checked={regla.operador === "or"}
                                                    onChange={() =>
                                                        actualizarRegla(regla.id, "operador", "or")
                                                    }
                                                />
                                                OR
                                            </label>
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <div className="col-5 px-3 py-3 bg-white border border-2 border-dark">
                            <div className="row">
                                <div className="col-6">
                                    <input
                                        id="submenuInput"
                                        type="text"
                                        className="form-control w-100"
                                        placeholder="Buscar..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>
                                <div className="col-6">
                                    <div className="dropdown w-auto">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Filtrar por
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li style={{ cursor: "pointer", margin: "5px" }} onClick={() => handleFilterClick("ENABLED")}>State Enabled</li>
                                            <li style={{ cursor: "pointer", margin: "5px" }} onClick={() => handleFilterClick("PAUSED")}>State Paused</li>
                                            <li style={{ cursor: "pointer", margin: "5px" }} onClick={() => handleFilterClick("ALL")}>Sin Filtro</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <h3 className="my-3">{tituloInformacion}</h3>
                            {selectedFunction !== "Select" && (
                                <div className="checkbox-actions1">
                                    <button
                                        className="btn btn-secondary mx-2 my-2"
                                        onClick={handleSelectAll}
                                        disabled={!modoEdicion}
                                    >
                                        Seleccionar todo
                                    </button>
                                    <button
                                        className="btn btn-danger mx-2 my-2"
                                        onClick={handleClearAll}
                                        disabled={!modoEdicion}
                                    >
                                        Limpiar todo
                                    </button>
                                </div>
                            )}

                            {(selectedFunction === "Adgroups" ? dataAdgroups : [])
                                .map((campaign, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>
                                        <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(campaign.campaignId)}
                                        >
                                            <span className="float-start">
                                                {isOpen[campaign.campaignId]
                                                    ? "▼ "
                                                    : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                Campaña: {campaign.name.replaceAll("_", " ")}
                                            </span>
                                            <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                State: {campaign.state} <br />
                                                Type: {campaign.type}
                                            </span>

                                        </button>
                                        {isOpen[campaign.campaignId] && (
                                            <div className="adgroup-options">
                                                {campaign.adGroups.map((adgroup, index) => (
                                                    <div key={`adgroup-${adgroup.adGroupId}-${index}`}
                                                        className="form-control d-flex align-items-center justify-content-evenly">
                                                        <input type="checkbox" className="mx-3" disabled={!modoEdicion} checked={
                                                            checkboxes?.[adgroup.adGroupId] || false} onChange={() =>
                                                                handleCheckboxChange(adgroup.adGroupId)}
                                                            id={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}
                                                        />
                                                        <label style={{ fontSize: "14px" }} htmlFor={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}>
                                                            AdGroup: {adgroup.name.replaceAll("_", " ")}
                                                        </label>
                                                        <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>Status: {adgroup.state}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )
                                )}

                            {(selectedFunction === "Campaigns" ? dataCampaign : [])
                                .map((campaign, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>

                                        <div className="row px-0 mx-0">
                                            <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                                <input
                                                    type="checkbox"
                                                    disabled={!modoEdicion}
                                                    checked={checkboxes?.[campaign.campaignId] || false}
                                                    onChange={() => handleCheckboxChange(campaign.campaignId)}
                                                    className="form-check-input h-50 w-100 border border-1 border-dark"
                                                />
                                            </div>
                                            <div className="col-11">
                                                <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(campaign.campaignId)}
                                                >
                                                    <span className="float-start">
                                                        {isOpen[campaign.campaignId]
                                                            ? "▼ "
                                                            : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                        Campaña: {campaign.name.replaceAll("_", " ")}
                                                    </span>
                                                    <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                        State: {campaign.state} <br />
                                                        Type: {campaign.type}
                                                    </span>

                                                </button>
                                            </div>
                                            <div className="col-12">
                                                {isOpen[campaign.campaignId] && (
                                                    <div className="adgroup-options">
                                                        {campaign.adGroups.map((adgroup, index) => (
                                                            <div key={`adgroup-${adgroup.adGroupId}-${index}`}
                                                                className="form-control d-flex align-items-center justify-content-evenly">
                                                                <label style={{ fontSize: "14px" }}>
                                                                    AdGroup: {adgroup.name.replaceAll("_", " ")}
                                                                </label>
                                                                <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>Status: {adgroup.state}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                                )}

                            {(selectedFunction === "Portafolios" ? dataPortafolios : [])
                                .map((portafolio, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>
                                        <div className="row px-0 mx-0">
                                            <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                                <input
                                                    disabled={!modoEdicion}
                                                    type="checkbox"
                                                    checked={checkboxes?.[portafolio.portfolioId] || false}
                                                    onChange={() => handleCheckboxChange(portafolio.portfolioId)}
                                                    className="form-check-input h-50 w-100 border border-1 border-dark"
                                                />
                                            </div>
                                            <div className="col-11">
                                                <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(portafolio.portfolioId)}
                                                >
                                                    <span className="float-start">
                                                        {isOpen[portafolio.portfolioId]
                                                            ? "▼ "
                                                            : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                        Portafolio: {portafolio.name.replaceAll("_", " ")}
                                                    </span>
                                                    <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                        State: {portafolio.state} <br />
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="col-12">
                                                {isOpen[portafolio.portfolioId] && (
                                                    <div className="adgroup-options">
                                                        {portafolio.campaigns.map((campaign, index) => (
                                                            <div key={`campaign-${campaign.campaignId}-${index}`}
                                                                className="form-control d-flex align-items-center justify-content-evenly">
                                                                <label style={{ fontSize: "14px" }}>
                                                                    Campaña: {campaign.name.replaceAll("_", " ")}
                                                                </label>
                                                                <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                                    Status: {campaign.state}<br />
                                                                    Type: {campaign.type}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                                )}

                            {(selectedFunction === "Asins" ? dataProductos : [])
                                .map((producto, idx) => (
                                    <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>

                                        <div className="row px-0 mx-0">
                                            <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                                <input
                                                    disabled={!modoEdicion}
                                                    type="checkbox"
                                                    checked={checkboxes?.[producto.adId] || false}
                                                    onChange={() => handleCheckboxChange(producto.adId)}
                                                    className="form-check-input h-50 w-100 border border-1 border-dark"
                                                />
                                            </div>
                                            <div className="col-11">
                                                <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(producto.adId)}
                                                >
                                                    <span className="float-start">
                                                        {isOpen[producto.adId]
                                                            ? "▼ "
                                                            : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                        ASIN: {producto.asin.replaceAll("_", " ") || "ASIN sin nombre"}
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="col-12">
                                                {isOpen[producto.adId] && (
                                                    <div className="adgroup-options">
                                                        {producto.campaigns.map((campaign, index) => (
                                                            <div key={`campaign-${campaign.campaignId}-${index}`}
                                                                className="form-control d-flex align-items-center justify-content-evenly">
                                                                <label style={{ fontSize: "14px" }}>
                                                                    Campaña: {campaign.name.replaceAll("_", " ")}
                                                                </label>
                                                                <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                                    Status: {campaign.state}<br />
                                                                    Type: {campaign.type}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                                )}

                        </div>
                    </div>
                </main>
                {showSaveModal && (
                    <div className="modal1-overlay">
                        <div className="modal1">
                            <label className="fs-4 text-center my-3">¿Deseas guardar los cambios?</label>
                            <div className="modal1-buttons">
                                <button className="btn btn-success" onClick={handleSave}>
                                    Sí, guardar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowSaveModal(false)}
                                >
                                    No, cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {showRevertModal && (
                    <div className="modal1-overlay">
                        <div className="modal1">
                            <label className="fs-4 text-center my-3">
                                ¿Estás seguro de que deseas deshacer los cambios?
                            </label>
                            <div className="modal1-buttons">
                                <button className="btn btn-success" onClick={handleRevert}>
                                    Sí, deshacer
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowRevertModal(false)}
                                >
                                    No, cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {showDeleteModal && (
                    <div className="modal1-overlay">
                        <div className="modal1">
                            <label className="fs-4 text-center my-3">
                                ¿Estás seguro de que deseas eliminar este parámetro?
                            </label>
                            <div className="modal1-buttons">
                                <button className="btn btn-success" onClick={handleDelete}>
                                    Sí, eliminar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowDeleteModal(false)}
                                >
                                    No, cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default VistaParametrosLectura;